import React, { Component } from "react";
import "./VideoSlider.scss"
import { getPercentagesFromValues, getActiveTrackStyle, FormatLabel } from "./sliderUtils"
import { Range } from 'react-range';
import "./VideoSlider.scss"
const STEP = 1000;
const MAX_DURATION = 8000;

class InputRangeSlider extends Component {
    state = {
        values: [0, 0]
    }
    componentDidMount = () => {
        const { max } = this.props
        const durationMax = Math.min(max, MAX_DURATION);
        this.setState({ values: [0, durationMax] })
    }
    onChange = values => {
        let [min, max] = values;
        const gap = max - min;
        //최대 8초
        if (gap > MAX_DURATION) return;
        //최소 1초
        if (gap < STEP) return;

        if (min < 0) return;
        if (max > this.props.max) return;

        this.setState({ values: [min, max] })
        this.props.onChangeTime({ min, max })
    }
    render() {
        const { max = 0, rtl, disabled } = this.props;
        const { values } = this.state

        const MAX = max / STEP


        let lengthMinutes = Math.floor((MAX === 0) ? 0 : MAX / 60)
        let lengthSeconds = Math.floor(MAX % 60)

        if (lengthSeconds < 10) lengthSeconds = "0" + lengthSeconds
        if (lengthMinutes < 10) lengthMinutes = "0" + lengthMinutes
        
        const percentages = getPercentagesFromValues(values, 0, max);

        return (
            <div className="gif-slider-root">
                 <div className='gif-slider-curTime'>00:00</div>
                <Range
                    draggableTrack
                    values={values}
                    step={STEP}
                    min={0}
                    max={max}
                    rtl={rtl}
                    disabled={disabled}
                    ref={ref => this.props.setRef ? this.props.setRef(ref) : undefined}
                    onChange={this.onChange}
                    renderTrack={({ props, children }) => {
                        const activeTrackStyle = getActiveTrackStyle(percentages);
                        return (
                            <div
                                className={`track-container ${disabled ? "disabled" : ""}`}
                                style={{
                                    ...props.style,
                                    height: '36px',
                                    display: 'flex',
                                    width: '100%',
                                    cursor:"unset"
                                }}
                            >
                                <div
                                    className="track-background"
                                    ref={props.ref}
                                    style={{
                                        width: '100%',
                                        alignSelf: 'center',
                                        position: "relative"
                                    }}
                                >
                                    <div
                                        className="track-active"
                                        onMouseDown={props.onMouseDown}
                                        onTouchStart={props.onTouchStart}
                                        style={{ ...activeTrackStyle }}
                                    >

                                    </div>
                                    {children}
                                </div>
                            </div>
                        )
                    }}
                    renderThumb={({ props }) => (
                        <div
                            {...props}
                            className="track-handler"
                            style={{
                                ...props.style,
                                
                            }}
                        >
                            <div className="track-label">{FormatLabel(values[props.key])}</div>
                        </div>
                    )}
                />           
                <div className='gif-slider-duration'>{`${lengthMinutes}:${lengthSeconds}`}</div>
            </div>
        )
    }
}
export default InputRangeSlider